import { Serializable } from '../../model/sidebar-query-params.model';

export class NumberSerializerBase implements Serializable<number> {
  deserialize(value: string): number {
    return +value;
  }

  serialize(value: number): string {
    return value.toString();
  }
}
